import React from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    FORM
} from "../../../components/i18n/i18n";
import {ButtonCancel, ButtonSubmit, GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ErrorMessage} from "react-hook-form";
import Select from "react-select";
import Switch from "react-bootstrap-switch";
import {TT_HISTORY} from "../../../components/i18n/toolTips";

export default function CurrencyMainForm(props) {
    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    props.editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={props.showHistory}
                        />
                    </div>
                }

            </CardTitle>
            <CardBody>
                <Form onSubmit={props.handleSubmit(props.submit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="text" name="id"
                                       disabled
                                       innerRef={props.register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="uid">UID Firebase</Label>
                                <Input type="text" name="uid"
                                       disabled
                                       innerRef={props.register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>



                    <Row>
                        <Col>
                            <FormGroup>
                                <Label htmlFor="name">Nombre</Label>
                                <Input type="text" name="name"
                                       disabled
                                       innerRef={props.register}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor="id">ISO (3)</Label>
                                <Input type="text" name="currency"
                                       disabled
                                       innerRef={props.register}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor="symbol">Símbolo</Label>
                                <Input type="text" name="symbol"
                                       disabled
                                       innerRef={props.register}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor="icon">Ícono</Label>
                                <Input type="text" name="icon"
                                       disabled
                                       innerRef={props.register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>


                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Codigo de pais</Label>
                                <Input type="text" name="countryCode"
                                       placeholder="Codigo de pais"
                                       innerRef={props.register}
                                       disabled={props.disableInputs}
                                       className={(props.errors.countryCode ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={props.errors} name="countryCode" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>

                        <Col md="4">
                            <FormGroup>
                                <Label>Bandera</Label>
                                <Input type="text" name="flag"
                                       placeholder="Bandera"
                                       innerRef={props.register}
                                       disabled={props.disableInputs}
                                       className={(props.errors.flag ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={props.errors} name="flag" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>

                        <Col md="4">
                            <FormGroup>
                                <Label>Separador Miles</Label>
                                <Select name="sepMiles"
                                        value={props.sepMiles}
                                        options={props.separadores}
                                        placeholder="Selecciona una opción"
                                        isDisabled={props.disableInputs}
                                        ref={props.register}
                                        onChange={props.setSepMiles}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Separador Decimal</Label>
                                <Select name="sepDecimal"
                                        value={props.sepDecimal}
                                        options={props.separadores}
                                        placeholder="Selecciona una opción"
                                        isDisabled={props.disableInputs}
                                        ref={props.register}
                                        onChange={props.setSepDecimal}
                                />
                            </FormGroup>
                        </Col>

                        <Col md="3">
                            <FormGroup>
                                <Label>ISO Payment</Label>
                                <Input type="text" name="isoPayment"
                                       placeholder="ISO Payment"
                                       innerRef={props.register}
                                       disabled={props.disableInputs}
                                       className={(props.errors.isoPayment ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={props.errors} name="isoPayment" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>

                        <Col md="3">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={props.status}
                                        disabled={props.disableInputs}
                                        onChange={_ => props.setStatus(!props.status)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{'Venta en Piso'}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={props.saleActivityStatus}
                                        disabled={props.disableInputs}
                                        onChange={_ => props.setSaleActivityStatus(!props.saleActivityStatus)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            props.saveSuccess ?
                                <div className="float-right">
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    )
}